import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { isNotEmptyArray } from 'utils';
import LinkBack from '../widgets/LinkBack';
import Chart from './Chart';

import './chart.scss';
import Spinner from '../widgets/Spinner';

class ChartTemplate extends PureComponent {
  render() {
    return (
      <div className="chart">
        <Helmet>
          <title>График доходности</title>
        </Helmet>

        <div className="container">
          <LinkBack link="/we/subnavigation/">
            мы <i>вернуться</i>
          </LinkBack>

          <div className="chart-content">
            <h1>Проекционное <br/>сравнение доходности</h1>
            <h2>За период реализации проектов</h2>

            {(isNotEmptyArray(this.props.chartPoints)) &&
              <Chart
                points={this.props.chartPoints}
              />
            }

            {(!isNotEmptyArray(this.props.chartPoints) && this.props.isChartFetching) &&
              <div className="chart-spinner">
                <Spinner />
              </div>
            }

            <div className="chart-legend">
              <span className="chart-legend-label-usc">
                Доходность программы USC
              </span>

              <span className="chart-legend-label-deposit">
                Доходность депозита
              </span>

              <span className="chart-legend-label-reference">
                Индекс МосБиржи
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ChartTemplate.propTypes = {
  chartPoints: PropTypes.array,
  isChartFetching: PropTypes.bool.isRequired
};

export default ChartTemplate;



// WEBPACK FOOTER //
// ./src/components/Chart/ChartTemplate.js